import { useEffect, useRef, useState } from "react";
import { ImpactPoint } from "src/types";

export type VehicleImpactPointCellProps = {
  impactPoint?: ImpactPoint;
  svgSrc: string;
  isSelected: boolean;
  onClick: () => void;
  fillColor: string;
  opacityColor: string;
  borderColor: string;
};

export const useVehicleImpactPointCell = ({
  svgSrc,
  isSelected,
  fillColor,
  opacityColor,
  borderColor,
}: VehicleImpactPointCellProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [svgLoaded, setSvgLoaded] = useState(false);

  //Load svg
  useEffect(() => {
    const loadSvg = async () => {
      try {
        const response = await fetch(svgSrc);
        const svgText = await response.text();

        if (containerRef.current) {
          containerRef.current.innerHTML = svgText;
          setSvgLoaded(true);
        }
      } catch (error) {
        console.error("Errore caricamento SVG:", error);
      }
    };

    if (svgSrc) {
      loadSvg();
    }
  }, [svgSrc]);

  //Manage image filling
  useEffect(() => {
    if (svgLoaded && containerRef.current) {
      const pathToFill = containerRef.current.querySelector("#path-to-fill");
      if (pathToFill) {
        pathToFill.setAttribute("fill", isSelected ? fillColor : "transparent");
      }

      const opacityToFill =
        containerRef.current.querySelector("#opacity-to-fill");
      if (opacityToFill) {
        opacityToFill.setAttribute("fill", opacityColor);
      }

      const bordersToStroke = containerRef.current.querySelectorAll(
        '[id^="border-to-stroke"]',
      );
      bordersToStroke.forEach((element) => {
        element.setAttribute("stroke", borderColor);
      });
    }
  }, [svgLoaded, isSelected, fillColor, opacityColor, borderColor]);

  return { containerRef };
};
